export enum ActiveColor {
  PRIMARY = 'primary',
  INHERIT = 'inherit',
}

export enum CaptionType {
  DEFAULT = 'default',
  CUSTOM = 'custom',
}

export enum AspectRatio {
  // 4 / 3 ratio
  DEFAULT = 'default',
  // 16 / 9 ratio
  WIDE = 'wide',
}
